/* ===========================================================
   Area S51 — Händlersuche (harmonisiert, neuer Flow)
   PLZ-first → Werkstatt + Online-Ersatzteile + weitere (gruppiert)
   =========================================================== */
"use strict";

const CATS = [
  { key: "werkstatt",        ico: "🔧", label: "Werkstatt & Reparatur", group: "hero",    pred: f => f.workshop || f.vehiclerepairs },
  { key: "online_shops", ico: "🛒", label: "Simson Onlineshops", group: "hero", online: true, pred: f => f.onlineshopavailable },
  { key: "fahrzeughaendler", ico: "🏍️", label: "Fahrzeughändler", group: "Kaufen",       pred: f => f.vehicletrade },
  { key: "fanartikel",       ico: "🏁", label: "Fanartikel & Zubehör", group: "Kaufen",   pred: f => f.simsonfanarticles },
  { key: "motorservice",     ico: "🛡️", label: "Autorisierter Motorservice", group: "Service", pred: f => f.servicepoint },
  { key: "tuev",             ico: "📋", label: "TÜV-Abnahme", group: "Service",            pred: f => f.mot },
  { key: "abholservice",     ico: "🚚", label: "Hol- & Bringservice", group: "Service",    pred: f => f.abholservice },
  { key: "tuning",           ico: "⚡", label: "Tuning", group: "Spezial",                 pred: f => f.tuning },
  { key: "restauration",     ico: "🛠️", label: "Restauration & Aufbau", group: "Spezial",  pred: f => f.vehiclestructure },
  { key: "lackierung",       ico: "🎨", label: "Lackierung & Oberflächen", group: "Spezial", pred: f => f.vehiclepainting || f.powdercoating || f.sandblasting || f.polishing || f.foiling || f.chromeplating },
  { key: "tank",             ico: "⛽", label: "Tankrestauration", group: "Spezial",       pred: f => f.tankregeneration },
  { key: "sattler",          ico: "🪑", label: "Sattler & Sitzbänke", group: "Spezial",    pred: f => f.saddlerwork },
  { key: "vape",             ico: "🔌", label: "VAPE / Powerdynamo", group: "Spezial",     pred: f => f.prempartvapepowerdyn },
];
const CAT = Object.fromEntries(CATS.map(c => [c.key, c]));
const GROUPS = ["Kaufen", "Service", "Spezial"];

// Shopify-Config (in der Section via Liquid injiziert); lokaler Fallback fürs Prototyping
const CFG = window.ARES51_CONFIG || {};
const DATA = {
  dealers: CFG.dealers || "swhv-dealers.json",
  plz: CFG.plz || "swhv-plz.json",
  picks: CFG.picks || "swhv-picks.json",
};
const LOGO_BASE = CFG.logoBase || "";

let DEALERS = [], PLZ = {}, PICKS = {};
const root = document.getElementById("a51");
const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const slug = s => String(s).toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");

// ---- PLZ-Feld: Icons, Texte, Normalisierung ----
// Inline-SVG statt Emoji (CONVENTIONS §3); Farbe/Strichstaerke kommen aus .a51 .ic.
const ICON = {
  pin:   '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s6.5-6 6.5-10.5a6.5 6.5 0 1 0-13 0C5.5 15 12 21 12 21z"/><circle cx="12" cy="10.5" r="2.4"/></svg>',
  pen:   '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 19.5h4L19 9a2.12 2.12 0 0 0-3-3L5.5 16.5v3z"/><path d="m14.5 6.5 3 3"/></svg>',
  check: '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 5 5 9-10.5"/></svg>',
  close: '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>',
  warn:  '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 4.5 20.5 19.5h-17L12 4.5z"/><path d="M12 10.5v3.6"/><path d="M12 17h.01"/></svg>',
};

const PLZ_RE = /^\d{5}$/;

const T = {
  chipLabel:      (plz, ort) => ort ? `Postleitzahl ${plz}, ${ort} – ändern` : `Postleitzahl ${plz} – ändern`,
  chipEmpty:      "PLZ eingeben",
  chipEmptyLabel: "Postleitzahl eingeben – sortiert nach Entfernung",
  inputLabel:     "Deine Postleitzahl",
  placeholder:    "z. B. 04109",
  confirmLabel:   "Postleitzahl übernehmen",
  cancelLabel:    "Abbrechen",
  hintEmpty:      "Fünf Ziffern eingeben",
  hintPartial:    n => n === 1 ? "Noch 1 Ziffer" : `Noch ${n} Ziffern`,
  notFound:       "PLZ nicht gefunden – bitte prüfen.",
  preview:        (ort, bl) => (bl && bl !== ort) ? `${ort} · ${bl}` : ort,
  foundSR:        (ort, bl) => (bl && bl !== ort) ? `${ort}, ${bl} gefunden.` : `${ort} gefunden.`,
  notFoundSR:     "PLZ nicht gefunden.",
  // Naeherung: wir kennen die PLZ nicht exakt, aber ihr Umkreis reicht zum
  // Sortieren. Sagen wir offen, statt einen Ort zu erfinden.
  approxPreview:  bl => bl ? `Umkreis ${bl} – wir sortieren nach Entfernung` : "Umkreis erkannt – wir sortieren nach Entfernung",
  approxSR:       bl => bl ? `Postleitzahl im Umkreis ${bl} erkannt.` : "Postleitzahl erkannt.",
  savedSR:        (plz, ort) => ort
                    ? `Postleitzahl ${plz} gespeichert. Stützpunkte in ${ort} neu sortiert.`
                    : `Postleitzahl ${plz} gespeichert. Stützpunkte neu sortiert.`,
  mutedHint:      "Onlineshops liefern deutschlandweit – deine PLZ gilt für alle anderen Kategorien.",
};

// Nur Ziffern, max. 5 — fuehrende Nullen bleiben erhalten (01127 = Dresden).
// Deshalb niemals type="number" oder parseInt auf eine PLZ anwenden.
const normalizePlzInput = v => String(v == null ? "" : v).replace(/\D/g, "").slice(0, 5);
// hasOwnProperty statt PLZ[v]: sonst validieren "constructor", "toString" & Co. als Treffer.
const hasPlz = v => PLZ_RE.test(v) && Object.prototype.hasOwnProperty.call(PLZ, v);

// swhv-plz.json hat verstreute Loecher: 06772 (Graefenhainichen) fehlt, obwohl
// 06773/06774/06779 da sind — der Kunde landete in einer Sackgasse. Die Datei
// umzuschreiben verbietet der ADR vom 2026-08-03 (877 KB, ohne Build-Pipeline
// nicht reproduzierbar, naechster Datenimport setzt es lautlos zurueck), also
// loesen wir zur Laufzeit auf, in dieser Reihenfolge:
//   1. plzPatch aus swhv-picks.json — handgepflegt, importfest, gewinnt immer
//   2. exakter Treffer in swhv-plz.json
//   3. Schwerpunkt der 4-stelligen Praefixgruppe ("0677"), sonst der
//      3-stelligen Leitregion ("067") — approx:true
// Erst wenn auch die Leitregion unbekannt ist, bleibt es bei der echten
// Fehlermeldung (z. B. 00000).
let _plzIndex = null;
function plzIndex() {
  if (_plzIndex) return _plzIndex;
  const g4 = Object.create(null), g3 = Object.create(null);
  const add = (m, k, rec, pure) => {
    const g = m[k] || (m[k] = { rows: [], pure: [] });
    g.rows.push(rec);
    if (pure) g.pure.push(rec);
  };
  for (const k in PLZ) {
    if (!Object.prototype.hasOwnProperty.call(PLZ, k) || !PLZ_RE.test(k)) continue;
    const r = PLZ[k];
    if (!r || typeof r.lat !== "number" || typeof r.lng !== "number") continue;
    // Grossempfaenger-Zeilen fliegen aus der Mittelung: ihre Koordinate ist die
    // Firma, nicht das Zustellgebiet, und sie kann meilenweit danebenliegen
    // ("22781 Yves Rocher GmbH Finanzbuchhaltung" = Hamburger PLZ, Koordinate
    // in Baden-Wuerttemberg). Sie wuerden den Schwerpunkt ihrer Gruppe
    // verziehen. isOrgLike ist dieselbe, gegen diesen Datensatz validierte
    // Erkennung wie beim Ort-Label (ADR 2026-08-03).
    const pure = !isOrgLike(String(r.ort || "").trim());
    add(g4, k.slice(0, 4), r, pure);
    add(g3, k.slice(0, 3), r, pure);
  }
  _plzIndex = { g4: groupCentroids(g4), g3: groupCentroids(g3) };
  return _plzIndex;
}
// Schwerpunkt der Gruppe + haeufigstes Bundesland. "ort" bleibt bewusst leer:
// ortLabel() faellt dann auf das Bundesland zurueck, so behaupten wir nie einen
// Ort, den wir nicht kennen (ADR 2026-08-03: "schwaecher, aber nie falsch").
function groupCentroids(groups) {
  const out = Object.create(null);
  for (const key in groups) {
    // Nur echte Ortschaften; hat die Gruppe ausschliesslich Grossempfaenger,
    // sind die immer noch besser als gar keine Antwort.
    const rows = groups[key].pure.length ? groups[key].pure : groups[key].rows;
    let lat = 0, lng = 0;
    const tally = Object.create(null);
    for (const r of rows) {
      lat += r.lat; lng += r.lng;
      const b = String(r.bl || "").trim();
      if (b) tally[b] = (tally[b] || 0) + 1;
    }
    let bl = "", best = 0;
    for (const b in tally) if (tally[b] > best) { best = tally[b]; bl = b; }
    out[key] = { lat: lat / rows.length, lng: lng / rows.length, ort: "", bl, approx: true, n: rows.length };
  }
  return out;
}
function resolvePlz(v) {
  if (!PLZ_RE.test(v)) return null;
  const patch = PICKS && PICKS.plzPatch;
  if (patch && Object.prototype.hasOwnProperty.call(patch, v)) return patch[v];
  if (hasPlz(v)) return PLZ[v];
  const ix = plzIndex();
  return ix.g4[v.slice(0, 4)] || ix.g3[v.slice(0, 3)] || null;
}

// Drei Haendlerdatensaetze haben im Import ihre fuehrende Null verloren
// ("1558" statt 01558, Grossenhain/Zeitz/Saalfeld). Beim Rendern auffuellen
// statt die Datendatei zu aendern — gleiche Begruendung wie oben.
const zip5 = z => { const s = String(z == null ? "" : z).trim(); return /^\d{4}$/.test(s) ? "0" + s : s; };

// swhv-plz.json enthaelt Grossempfaenger-PLZ, deren "ort" eine Organisation ist
// ("N26 AG", "Deutsche Post AG RBZ Berlin EPOS-FI") — rund 18 % der Eintraege.
// Dann zeigen wir das Bundesland: schwaecher als der Ort, aber nie falsch.
// Der Rohwert steht im title des Chips.
const BL_FIX = {
  "Land Berlin": "Berlin",
  "Saxony-Anhalt": "Sachsen-Anhalt",
  "Mecklenburg-Western Pomerania": "Mecklenburg-Vorpommern",
};
const ORG_RE = /[0-9&]|\b(AG|GmbH|mbH|gGmbH|KG|KGaA|OHG|GbR|UG|SE|eG|AöR)\b|\be\.\s?V\.|\b(Amtsgericht|Finanzamt|Jobcenter|Job-Center|Bezirksamt|Ministerium|Agentur|Postfach|Sparkasse|Bank|Versicherung|Krankenkasse|Rentenversicherung|Verlag|Institut|Stiftung|Verwaltung|Zentrale|Gesellschaft|Verband|Genossenschaft|Konzern|Holding|Telekom|Landkreis)\b|\bLandes(amt|bank|betrieb|direktion|kreditbank|verwaltung|versicherung|kriminalamt|hauptkasse)\b|\b(Bundes|Universit|Klinik|Hochschule)\w*/;
const isOrgLike = s => ORG_RE.test(s) || s.split(/\s+/).length > 4 || s.length > 34;
const blLabel = rec => { const b = String((rec && rec.bl) || "").trim(); return BL_FIX[b] || b; };
function ortLabel(rec) {
  if (!rec) return "";
  const ort = String(rec.ort || "").trim();
  return (ort && !isOrgLike(ort)) ? ort : (blLabel(rec) || ort);
}

// ---- votes (DEMO: localStorage + seeded baseline.  PROD: tallies on dealer-metaobjects, written via App-Proxy → serverless, 1/device + IP rate-limit) ----
const VOTES = JSON.parse(localStorage.getItem("a51_votes") || "{}");
const hashId = id => { const s = String(id); let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; return h; };
const seedUp = id => (hashId(id) % 38) + 4;
const seedDown = id => (hashId(id) % 14);
const getV = id => VOTES[id] || { up: seedUp(id), down: seedDown(id), mine: 0 };
const vScore = id => { const v = getV(id); return v.up - v.down; };
const saveVotes = () => localStorage.setItem("a51_votes", JSON.stringify(VOTES));
function votePill(id) {
  const v = getV(id), s = v.up - v.down;
  return `<div class="vote" id="v${id}" title="Empfehlung der Community">
    <button class="vb up ${v.mine>0?"on":""}" aria-label="Empfehlen" onclick="A51.vote(${id},1)">▲</button>
    <span class="vscore ${s>0?"pos":s<0?"neg":""}">${s>0?"+":""}${s}</span>
    <button class="vb down ${v.mine<0?"on":""}" aria-label="Nicht empfehlen" onclick="A51.vote(${id},-1)">▼</button>
  </div>`;
}

function haversine(a, b) {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const R = 6371, r = x => x * Math.PI / 180;
  const dLa = r(b.lat - a.lat), dLo = r(b.lng - a.lng);
  const s = Math.sin(dLa/2)**2 + Math.cos(r(a.lat))*Math.cos(r(b.lat))*Math.sin(dLo/2)**2;
  return Math.round(2 * R * Math.asin(Math.sqrt(s)));
}
const DAYS = ["Mo","Di","Mi","Do","Fr","Sa","So"];
function openNow(h) {
  if (!h) return null;
  const n = new Date(), i = (n.getDay()+6)%7, t = h[i];
  if (!t) return { open:false, txt:"Heute geschlossen" };
  const m = String(t).match(/(\d{1,2}):(\d{2})\D+(\d{1,2}):(\d{2})/);
  if (!m) return null;
  const cur = n.getHours()*60+n.getMinutes(), f=+m[1]*60+ +m[2], to=+m[3]*60+ +m[4], open = cur>=f&&cur<=to;
  return { open, txt: (open?"Jetzt geöffnet":"Geschlossen")+" · "+DAYS[i]+" "+t };
}

// ---- pinned (featured) resolution ----
function pinnedFor(catKey, coords) {
  const af = PICKS.alwaysFirst && PICKS.alwaysFirst[catKey];
  if (af) {
    const obj = (typeof af === "string") ? (af === "ares51" ? PICKS.areaS51 : PICKS[af]) : null;
    const d = obj ? { ...obj, _ares51: true, services: obj.services || [], flags: {} }
                  : DEALERS.find(x => x.id === af);
    if (d) return { d: { ...d, dist: coords && d.lat != null ? haversine(coords, d) : null }, reason: "always" };
  }
  if (coords && !CAT[catKey].online) {
    const ids = (PICKS.recommended && PICKS.recommended[catKey]) || [];
    const c = DEALERS.filter(x => ids.includes(x.id) && CAT[catKey].pred(x.flags))
      .map(x => ({ ...x, dist: haversine(coords, x) }))
      .filter(x => x.dist != null && x.dist <= (PICKS.recommendRadiusKm || 100))
      .sort((a, b) => a.dist - b.dist);
    if (c.length) return { d: c[0], reason: "recommended" };
    // Gepruefte Partner mit eigenem Umkreis (partnerPins in swhv-picks.json):
    // erscheinen in allen PLZ-Kategorien ausser excludeCats, auch ohne
    // passende MZA-Flags. Der naechstgelegene innerhalb seines Radius gewinnt.
    const pp = (PICKS.partnerPins || [])
      .filter(p => !(p.excludeCats || []).includes(catKey))
      .map(p => { const x = DEALERS.find(y => y.id === p.id); return x && { ...x, name: p.name || x.name, dist: haversine(coords, x), _r: p.radiusKm || 0 }; })
      .filter(x => x && x.dist != null && x.dist <= x._r)
      .sort((a, b) => a.dist - b.dist);
    if (pp.length) return { d: pp[0], reason: "recommended" };
  }
  return null;
}
function rank(catKey, coords, bl) {
  const cat = CAT[catKey];
  let pool = DEALERS.filter(d => cat.pred(d.flags));
  if (bl) pool = pool.filter(d => slug(d.bl) === bl);
  const pin = pinnedFor(catKey, coords);
  let list = pool.map(d => ({ ...d, dist: coords ? haversine(coords, d) : null }));
  if (pin && pin.d && typeof pin.d.id === "number") list = list.filter(d => d.id !== pin.d.id);
  if (cat.online) list.sort((a, b) => vScore(b.id) - vScore(a.id) || a.name.localeCompare(b.name, "de"));
  else if (coords) {
    // distance primary, votes boost: a well-rated dealer counts as up to 18 km "closer"
    const eff = d => Math.max(0, (d.dist ?? 1e9) - Math.min(18, Math.max(0, vScore(d.id) * 1.5)));
    list.sort((a, b) => eff(a) - eff(b));
  } else list.sort((a, b) => a.name.localeCompare(b.name, "de"));
  return { pin, list, total: pool.length };
}

// ---- pieces ----
function logo(d) {
  const raw = d.logo || "";
  let src = "";
  if (raw) src = /^(https?:|\/\/)/.test(raw) ? raw : (LOGO_BASE ? LOGO_BASE + raw : "");
  if (src) return `<img class="logo" src="${esc(src)}" alt="${esc(d.name)} Logo" loading="lazy" onerror="this.className='logo ph';this.removeAttribute('src');this.textContent='${esc((d.name[0]||'S').toUpperCase())}'">`;
  return `<div class="logo ph">${esc((d.name[0]||"S").toUpperCase())}</div>`;
}
function icons(d) {
  const o = [];
  if (d.phone) o.push(`<a class="ic" href="tel:${esc(d.phone.replace(/\s/g,""))}" title="Anrufen">☎</a>`);
  if (d.email) o.push(`<a class="ic" href="mailto:${esc(d.email)}" title="E-Mail">✉</a>`);
  if (d.website) o.push(`<a class="ic" href="${esc(d.website)}" target="_blank" rel="noopener" title="Webseite">🌐</a>`);
  if (!CAT_ONLINE_VIEW && d.lat != null) o.push(`<a class="ic" href="https://www.google.com/maps/dir/?api=1&destination=${d.lat},${d.lng}" target="_blank" rel="noopener" title="Route">📍</a>`);
  return `<div class="icons">${o.join("")}</div>`;
}
let CAT_ONLINE_VIEW = false;
const prettyUrl = u => String(u).replace(/^https?:\/\//, "").replace(/^www\./, "").replace(/\/$/, "");
function contactRow(d, online) {
  const o = [];
  if (d.phone) o.push(`<a class="cl" href="tel:${esc(d.phone.replace(/\s/g,""))}"><span class="ci">☎</span>${esc(d.phone)}</a>`);
  if (d.email) o.push(`<a class="cl" href="mailto:${esc(d.email)}"><span class="ci">✉</span>${esc(d.email)}</a>`);
  if (d.website) o.push(`<a class="cl web" href="${esc(d.website)}" target="_blank" rel="noopener"><span class="ci">🌐</span>${esc(prettyUrl(d.website))}</a>`);
  if (!online && d.lat != null) o.push(`<a class="cl" href="https://www.google.com/maps/dir/?api=1&destination=${d.lat},${d.lng}" target="_blank" rel="noopener"><span class="ci">📍</span>Route</a>`);
  return o.length ? `<div class="c-contact">${o.join("")}</div>` : "";
}
function tags(d, online) {
  const all = (d.services || []).filter(s => !/online/i.test(s));
  const t = [];
  if (d.flags && d.flags.onlineshopavailable) t.push(`<span class="tag on">Online-Shop</span>`);
  all.slice(0, 3).forEach(s => t.push(`<span class="tag">${esc(s)}</span>`));
  const extra = all.length - 3;
  if (extra > 0) t.push(`<span class="tag more">+${extra}</span>`);
  return t.length ? `<div class="c-tags">${t.join("")}</div>` : "";
}
function distEl(d, online) {
  if (online || d.nationwide) {
    if (d.nationwide) return `<div class="dist online">deutschlandweit</div>`;
    return `<div class="dist online">Online-Shop</div>`;
  }
  if (d.dist == null) return "";
  return `<div class="dist">≈ ${d.dist}<small> km</small></div>`;
}
function card(d, online, rank) {
  const on = !online && openNow(d.hours);
  return `<article class="card">
    <div class="c-rank">${rank != null ? (rank < 10 ? "0" + rank : rank) : ""}</div>
    ${logo(d)}
    <div class="c-main">
      <div class="c-name">${esc(d.name)}</div>
      <div class="c-addr">${d.street?esc(d.street)+" · ":""}${esc(zip5(d.zip))} ${esc(d.city)}${d.bl?` · ${esc(d.bl)}`:""}</div>
      ${contactRow(d, online)}
      ${tags(d, online)}
      ${on ? `<div class="open ${on.open?"y":"n"}">${esc(on.txt)}</div>` : ""}
    </div>
    <div class="c-side">${distEl(d, online)}${votePill(d.id)}</div>
  </article>`;
}
function featCard(d, reason, online) {
  const note = reason === "always"
    ? (d.tagline || (online ? "Unser Top-Shop für Simson-Ersatzteile" : "Unsere Nr. 1 Empfehlung"))
    : "Von Area S51 geprüfter Partner in deiner Region.";
  return `<article class="card feat">
    <div class="feat-strip">★ Unsere Empfehlung</div>
    <div class="feat-inner">
      ${logo(d)}
      <div class="c-main">
        <div class="c-name">${esc(d.name)}</div>
        <div class="c-addr">${d.street?esc(d.street)+" · ":""}${esc(zip5(d.zip))} ${esc(d.city)}${d.bl?` · ${esc(d.bl)}`:""}</div>
        <div class="feat-note">${esc(note)}</div>
        ${Array.isArray(d.usps) && d.usps.length ? `<div class="feat-usps">${d.usps.map(u => `<span>✓ ${esc(u)}</span>`).join("")}</div>` : ""}
        ${d.voucher ? `<div class="voucher">🎟️ Exklusiv bei Area&nbsp;S51: Code <b>${esc(d.voucher)}</b></div>` : ""}
        ${contactRow(d, online)}
        ${tags(d, online)}
      </div>
      <div class="c-side">${distEl(d, online)}${d.website?`<a class="btn-cta" href="${esc(d.website)}" target="_blank" rel="noopener">Zum Händler →</a>`:""}</div>
    </div>
  </article>`;
}
function plzChip(mode) {
  const plz = state.plz || "";
  const rec = resolvePlz(plz);
  const ort = rec ? ortLabel(rec) : "";
  const rawOrt = rec ? String(rec.ort || "").trim() : "";
  const muted = mode === "muted";
  return `<form class="plz-chip${muted ? " is-muted" : ""}" novalidate autocomplete="off">
    <button type="button" class="chip-face" aria-label="${esc(plz ? T.chipLabel(plz, ort) : T.chipEmptyLabel)}"${muted ? ` title="${esc(T.mutedHint)}"` : ""}>
      ${ICON.pin}
      ${plz
        ? `<span class="chip-plz">${esc(plz)}</span>${ort ? `<span class="chip-sep" aria-hidden="true">·</span><span class="chip-ort" title="${esc(rawOrt)}">${esc(ort)}</span>` : ""}`
        : `<span class="chip-plz">${esc(T.chipEmpty)}</span>`}
      <span class="chip-pen">${ICON.pen}</span>
    </button>
    <span class="chip-edit">
      ${ICON.pin}
      <label class="a51-sr" for="a51-plz-input">${esc(T.inputLabel)}</label>
      <input id="a51-plz-input" class="chip-input" type="text" inputmode="numeric" pattern="[0-9]{5}"
        maxlength="5" autocomplete="postal-code" enterkeyhint="go" spellcheck="false" autocapitalize="off"
        aria-describedby="a51-plz-msg" aria-invalid="false" placeholder="${esc(T.placeholder)}" value="${esc(plz)}">
      <button type="submit" class="chip-btn chip-ok" aria-label="${esc(T.confirmLabel)}">${ICON.check}</button>
      <button type="button" class="chip-btn chip-cancel" aria-label="${esc(T.cancelLabel)}">${ICON.close}</button>
    </span>
    <span class="chip-msg" id="a51-plz-msg" hidden></span>
  </form>`;
}

// Wird nach jedem root.innerHTML einmal aufgerufen; die alten Listener sterben mit
// den alten Knoten, daher kein Leak und keine Delegation noetig.
function bindChip(scope) {
  const form = scope.querySelector(".plz-chip");
  if (!form) return;
  const face   = form.querySelector(".chip-face");
  const input  = form.querySelector(".chip-input");
  const msg    = form.querySelector(".chip-msg");
  const ok     = form.querySelector(".chip-ok");
  const cancel = form.querySelector(".chip-cancel");

  function setMsg(text, isError) {
    msg.innerHTML = (isError ? ICON.warn : "") + `<span>${esc(text)}</span>`;
    msg.className = "chip-msg" + (isError ? " is-error" : "");
    msg.hidden = !text;
  }
  function feedback() {
    const v = input.value;
    if (v.length < 5) {
      setMsg(v.length ? T.hintPartial(5 - v.length) : T.hintEmpty, false);
      input.setAttribute("aria-invalid", "false");
      form.classList.remove("is-invalid");
      ok.disabled = true;
      clearTimeout(_liveTimer);
      return;
    }
    const rec = resolvePlz(v);
    ok.disabled = false;
    if (rec) {
      const o = ortLabel(rec), b = blLabel(rec);
      setMsg(rec.approx ? T.approxPreview(b) : T.preview(o, b), false);
      input.setAttribute("aria-invalid", "false");
      form.classList.remove("is-invalid");
      announceSoon(rec.approx ? T.approxSR(b) : T.foundSR(o, b));
    } else {
      setMsg(T.notFound, true);
      input.setAttribute("aria-invalid", "true");
      form.classList.add("is-invalid");
      announceSoon(T.notFoundSR);
    }
  }
  function openEdit() {
    form.classList.add("is-editing");
    input.value = state.plz || "";
    feedback();
    input.focus();
    input.select();
  }
  function closeEdit(refocus) {
    clearTimeout(_liveTimer);
    form.classList.remove("is-editing", "is-invalid");
    input.value = state.plz || "";
    input.setAttribute("aria-invalid", "false");
    msg.hidden = true;
    msg.textContent = "";
    if (refocus !== false) face.focus({ preventScroll: true });
  }

  face.addEventListener("click", openEdit);
  input.addEventListener("input", () => {
    const n = normalizePlzInput(input.value);
    if (n !== input.value) input.value = n;
    feedback();
  });
  form.addEventListener("keydown", e => {
    if (e.key === "Escape" && form.classList.contains("is-editing")) {
      e.preventDefault();
      e.stopPropagation();
      closeEdit();
    }
  });
  // iOS Safari gibt Buttons beim Tippen keinen Fokus: focusout meldet dann
  // relatedTarget null und wuerde abbrechen, bevor der Klick ankommt.
  [ok, cancel].forEach(b => b.addEventListener("pointerdown", e => e.preventDefault()));
  cancel.addEventListener("click", () => closeEdit());
  form.addEventListener("focusout", e => {
    if (!form.classList.contains("is-editing")) return;
    if (e.relatedTarget && form.contains(e.relatedTarget)) return;
    closeEdit(false);
  });
  form.addEventListener("submit", e => {
    e.preventDefault();
    input.value = normalizePlzInput(input.value);
    const rec = resolvePlz(input.value);
    if (!rec) { feedback(); input.focus(); input.select(); return; }
    state.plz = input.value;
    save();
    PENDING = { focus: "chip", say: T.savedSR(state.plz, ortLabel(rec)) };
    route();
  });
}

// ---- kontextuelle Verlinkung in den Bestand (Shop, Guides) + Partner-CTA ----
function relatedLinks(catKey) {
  const L = PICKS.links || {};
  const sets = {
    hub:              [["Simson kaufen – Shop", L.shopMopeds], ["Ersatzteile-Shop", L.shopErsatzteile], ["S51 Konfigurator", L.konfigurator], ["S51 Kauf-Komplettguide", L.guideKauf]],
    fahrzeughaendler: [["Simson kaufen – Shop", L.shopMopeds], ["S51 Kauf-Komplettguide", L.guideKauf], ["Ratenkauf & Finanzierung", L.guideFinanzierung], ["S51 Konfigurator", L.konfigurator], ["Kennzeichen 2025", L.kennzeichen]],
    werkstatt:        [["Ersatzteile bestellen", L.shopErsatzteile], ["Rahmennummer prüfen", L.rahmennummer], ["Erste Schritte mit deiner S51", L.ersteSchritte], ["S51 winterfest machen", L.winterfest]],
    online_shops:     [["Unser Ersatzteile-Shop", L.shopErsatzteile], ["Ersatzteilliste Neuaufbauten", L.ersatzteilliste]],
    tuev:             [["Kennzeichen 2025", L.kennzeichen], ["KBA-Papiere", L.kbaPapiere], ["Warum legal 60 km/h", L.legal60]],
    restauration:     [["Mopeds & Neuaufbauten", L.shopMopeds], ["S51 Kauf-Komplettguide", L.guideKauf], ["Ersatzteilliste Neuaufbauten", L.ersatzteilliste]],
    motorservice:     [["Ersatzteile bestellen", L.shopErsatzteile], ["S51 Kauf-Komplettguide", L.guideKauf]],
  };
  const def = [["Simson kaufen – Shop", L.shopMopeds], ["Ersatzteile-Shop", L.shopErsatzteile], ["S51 Kauf-Komplettguide", L.guideKauf]];
  const items = (sets[catKey] || def).filter(x => x[1]);
  const rel = items.length
    ? `<div class="related"><div class="rel-title">Rund um Simson bei Area S51</div><div class="rel-links">${items.map(([t, u]) => `<a href="${esc(u)}">${esc(t)} →</a>`).join("")}</div></div>`
    : "";
  return rel + partnerCta();
}
function partnerCta() {
  const u = (PICKS.links || {}).partnerWerden;
  if (!u) return "";
  return `<div class="partner-cta"><div class="pc-text"><b>Du bist Händler oder Werkstatt?</b><br><span>Werde Area-S51-Partner und erscheine im Verzeichnis – auch ohne MZA-Listung.</span></div><a class="pc-btn" href="${esc(u)}">Partner werden →</a></div>`;
}

// ---------- views ----------
function viewLanding() {
  CAT_ONLINE_VIEW = false;
  root.innerHTML = `<div class="wrap land">
    <div class="eyebrow">Simson Händler-Verzeichnis</div>
    <h2 class="land-title">Finde deinen<br><span class="u">Simson-Stützpunkt</span></h2>
    <p class="lead">Werkstatt, Ersatzteile, Fahrzeuge & Service in deiner Nähe – gib deine Postleitzahl ein, wir sortieren nach Entfernung.</p>
    <form class="plz-hero" id="lf">
      <div class="plz-row"><span class="pin">📍</span>
        <label class="a51-sr" for="li">Deine Postleitzahl</label>
        <input id="li" inputmode="numeric" maxlength="5" placeholder="Deine PLZ – z. B. 04109" autocomplete="postal-code">
        <button type="submit" aria-label="Stützpunkte finden"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg></button>
      </div>
      <div class="plz-msg" id="lm"></div>
    </form>
    <div class="alt">Suchst du nur <a href="#/k/online_shops">Simson Onlineshops</a>? Dafür brauchst du keine PLZ.</div>
    <div class="trust"><span><b>über 960</b> Händler in Deutschland</span><span><b>16</b> Bundesländer</span><span>Geprüfte Empfehlungen</span></div>
  </div>`;
  const f = document.getElementById("lf");
  f.addEventListener("submit", e => {
    e.preventDefault();
    // Gleiche Normalisierung und gleicher Resolver wie in der Chip-Pille:
    // vorher lief hier ein rohes PLZ[v], das weder den Umkreis-Fallback noch
    // den Prototype-Schutz kannte und die Schuld faelschlich auf die
    // Stellenzahl schob ("bitte 5-stellig pruefen" bei 5 Ziffern).
    const input = document.getElementById("li");
    input.value = normalizePlzInput(input.value);
    const v = input.value;
    const lm = document.getElementById("lm");
    lm.textContent = "…";
    ensureData().then(() => {
      if (!resolvePlz(v)) { lm.textContent = v.length < 5 ? T.hintEmpty : T.notFound; return; }
      state.plz = v; save(); lm.textContent = ""; location.hash = "#/"; route();
    }).catch(dataErr);
  });
  // Daten (≈ 270 KB) erst bei der ersten Interaktion mit dem PLZ-Feld laden,
  // nicht beim Seitenaufruf. Kein Autofokus: H1 + Intro stehen jetzt darueber.
  const li = document.getElementById("li");
  const warm = () => ensureData().catch(() => {});
  li.addEventListener("focus", warm, { once: true });
  li.addEventListener("pointerdown", warm, { once: true });
}

function block(title, locBadge, innerHtml, moreHref, moreLabel) {
  return `<section class="block"><div class="block-head">
      <h3>${esc(title)} ${locBadge?`<span class="badge-loc">${esc(locBadge)}</span>`:""}</h3>
      ${moreHref?`<a class="more" href="${moreHref}">${esc(moreLabel)} →</a>`:""}
    </div>${innerHtml}</section>`;
}

function viewHub() {
  CAT_ONLINE_VIEW = false;
  const coords = resolvePlz(state.plz);
  // ① Werkstatt
  const w = rank("werkstatt", coords);
  let wHtml = `<div class="list">`;
  if (w.pin) wHtml += featCard(w.pin.d, w.pin.reason, false);
  wHtml += w.list.slice(0, 3).map((d, i) => card(d, false, i + 1)).join("") + `</div>`;
  // ② Online-Ersatzteile
  CAT_ONLINE_VIEW = true;
  const o = rank("online_shops", null);
  let oHtml = `<div class="list">`;
  if (o.pin) oHtml += featCard(o.pin.d, o.pin.reason, true);
  oHtml += o.list.slice(0, 5).map((d, i) => card(d, true, i + 1)).join("") + `</div>`;
  CAT_ONLINE_VIEW = false;
  // ③ groups
  const groupsHtml = GROUPS.map(g => {
    const tiles = CATS.filter(c => c.group === g).map(c => {
      const n = DEALERS.filter(d => c.pred(d.flags)).length;
      return `<a class="tile" href="#/k/${c.key}"><span class="ti">${c.ico}</span><span><span class="tt">${esc(c.label)}</span><br><span class="tc">${n} Stützpunkte</span></span></a>`;
    }).join("");
    return `<div class="grp"><div class="grp-label">${esc(g)}</div><div class="tiles">${tiles}</div></div>`;
  }).join("");

  root.innerHTML = `<div class="wrap res">
    <div class="res-bar"><h2 class="page">Deine Simson-Stützpunkte</h2>${plzChip()}</div>
    ${block("Werkstatt in deiner Nähe", "nach Entfernung", wHtml, "#/k/werkstatt", `Alle ${w.total} Werkstätten`)}
    ${block("Simson Onlineshops", "ohne PLZ – deutschlandweit", oHtml, "#/k/online_shops", `Alle ${o.total} Shops`)}
    ${block("Weitere Leistungen", "", `<div class="groups">${groupsHtml}</div>`)}
    ${relatedLinks("hub")}
  </div>`;
  bindChip(root);
  applyPending();
}

function viewCategory(key, bl) {
  const cat = CAT[key];
  if (!cat) { location.hash = "#/"; return; }
  const online = !!cat.online;
  CAT_ONLINE_VIEW = online;
  const coords = online ? null : resolvePlz(state.plz);
  const { pin, list, total } = rank(key, coords, bl);

  // region links (Bundesländer with dealers in this category)
  const blCounts = {};
  DEALERS.filter(d => cat.pred(d.flags)).forEach(d => { if (d.bl) blCounts[d.bl] = (blCounts[d.bl]||0)+1; });
  const regions = Object.entries(blCounts).sort((a,b)=>b[1]-a[1])
    .map(([name,n]) => `<a href="#/k/${key}/${slug(name)}" ${slug(name)===bl?'style="border-color:var(--red);color:var(--red)"':""}>${esc(name)} (${n})</a>`).join("");

  const blName = bl ? (Object.keys(blCounts).find(n => slug(n)===bl) || bl) : "";
  const crumb = `<div class="crumb"><a href="#/">Start</a> › <a href="#/">Händlersuche</a> › ${bl?`<a href="#/k/${key}">${esc(cat.label)}</a> › ${esc(blName)}`:esc(cat.label)}</div>`;
  const title = bl ? `${cat.label} in ${blName}` : cat.label;

  let body = "";
  if (!online && !coords) body += `<div class="notice">Gib deine <b>PLZ</b> oben ein – dann sortieren wir die ${total} Einträge nach Entfernung und zeigen unsere Empfehlung in deiner Nähe.</div>`;
  let html = `<div class="list">`;
  if (pin) html += featCard(pin.d, pin.reason, online);
  html += (online ? "" : "");
  const shown = list.slice(0, 60);
  html += shown.map((d, i) => card(d, online, i + 1)).join("") + `</div>`;
  if (list.length > shown.length) html += `<div class="notice" style="margin-top:12px">+ ${list.length - shown.length} weitere – mit PLZ verfeinern.</div>`;
  body += html;

  root.innerHTML = `<div class="wrap res">
    ${crumb}
    <div class="res-bar"><h2 class="page">${esc(title)}</h2>${plzChip(online ? "muted" : "")}</div>
    <div style="color:var(--muted);font-size:14px;margin:-2px 0 8px">${total} Einträge${bl?` in ${esc(blName)}`:""}${online?" · deutschlandweit, ohne PLZ":coords?` · rund um ${esc(state.plz)}`:""}</div>
    ${body}
    <div class="regionbar"><div class="rl-title">${esc(cat.label)} nach Bundesland</div><div class="reglinks">${regions}</div></div>
    ${relatedLinks(key)}
  </div>`;
  bindChip(root);
  applyPending();
}

// ---------- change-PLZ inline ----------
const A51 = {
  vote(id, dir) {
    const v = getV(id);
    if (v.mine === dir) { if (dir > 0) v.up--; else v.down--; v.mine = 0; }
    else { if (v.mine > 0) v.up--; else if (v.mine < 0) v.down--; if (dir > 0) v.up++; else v.down++; v.mine = dir; }
    VOTES[id] = v; saveVotes();
    const el = document.getElementById("v" + id);
    if (el) el.outerHTML = votePill(id);
  },
  // Shim: die Bearbeiten-Logik liegt jetzt in bindChip(). Bleibt nur, falls
  // extern noch jemand den Global aufruft.
  editPlz() {
    const face = root.querySelector(".plz-chip .chip-face");
    if (face) face.click();
  }
};
window.A51 = A51;

// ---------- Live-Region + Fokusuebergabe ueber den Re-Render hinweg ----------
// Die Live-Region haengt am body, NICHT in #a51: route() ueberschreibt
// root.innerHTML komplett und wuerde sie sonst mitsamt der Ansage loeschen.
let PENDING = null;
let _liveEl = null, _liveTimer = 0;
function ensureLive() {
  if (_liveEl && document.body.contains(_liveEl)) return _liveEl;
  _liveEl = document.getElementById("a51-live");
  if (!_liveEl) {
    _liveEl = document.createElement("span");
    _liveEl.id = "a51-live";
    _liveEl.className = "a51-sr";
    _liveEl.setAttribute("role", "status");
    _liveEl.setAttribute("aria-live", "polite");
    _liveEl.setAttribute("aria-atomic", "true");
    document.body.appendChild(_liveEl);
  }
  return _liveEl;
}
function announce(m) { clearTimeout(_liveTimer); ensureLive().textContent = m || ""; }
// Entprellt: sonst spricht der Screenreader bei jedem Anschlag.
function announceSoon(m) { clearTimeout(_liveTimer); _liveTimer = setTimeout(() => announce(m), 400); }
function applyPending() {
  if (!PENDING) return;
  const p = PENDING;
  PENDING = null;
  if (p.focus === "chip") {
    const el = root.querySelector(".plz-chip .chip-face");
    if (el) el.focus({ preventScroll: true });
  }
  if (p.say) announce(p.say);
}

// ---------- state ----------
const state = { plz: localStorage.getItem("a51_plz") || "" };
function save() { localStorage.setItem("a51_plz", state.plz || ""); }

// ---------- Daten lazy laden (blockiert NICHT den ersten Render / LCP) ----------
let _dataP = null;
function ensureData() {
  if (_dataP) return _dataP;
  _dataP = Promise.all([
    fetch(DATA.dealers).then(r => r.json()),
    fetch(DATA.plz).then(r => r.json()),
    fetch(DATA.picks).then(r => r.json()),
  ]).then(([d, p, pk]) => {
    DEALERS = Array.isArray(pk.customDealers) && pk.customDealers.length ? d.concat(pk.customDealers) : d;
    PLZ = p; PICKS = pk;
    _plzIndex = null; // gehoert zur alten PLZ-Referenz
  });
  return _dataP;
}
function dataErr(e) { root.innerHTML = `<div class="wrap"><div class="notice">Daten konnten nicht geladen werden: ${esc(e.message)}</div></div>`; }

// ---------- router ----------
function route() {
  const h = location.hash.replace(/^#/, "");
  const m = h.match(/^\/k\/([a-z_]+)(?:\/([a-z-]+))?/);
  if (m) { ensureData().then(() => viewCategory(m[1], m[2] || null)).catch(dataErr); return; }
  if (state.plz) {
    ensureData().then(() => {
      if (resolvePlz(state.plz)) { viewHub(); return; }
      // Unaufloesbarer Wert (typisch aus ?plz=...) darf nicht im localStorage
      // kleben bleiben — sonst landet der Nutzer bei jedem Aufruf kommentarlos
      // wieder auf der Landingpage.
      state.plz = ""; save();
      viewLanding();
    }).catch(dataErr);
    return;
  }
  viewLanding();
}

// ---------- boot ----------
const _q = new URLSearchParams(location.search).get("plz");
if (_q && /^\d{5}$/.test(_q)) { state.plz = _q; save(); }
ensureLive();
window.addEventListener("hashchange", route);
route();
